import apiService from "./api";
import { transformMealsForRestaurantCompanies } from "@/mappers/reportMapper";

const reportService = {
  getFoodOrdersOrdered(restaurantId, params) {
    return apiService.get(
      `/reports/daily/food-orders-ordered/${restaurantId}`,
      params
    );
  },
  getShiftOrderStatus(restaurantId, params) {
    return apiService.get(
      `/v2/reports/daily/restaurant/${restaurantId}/companies`,
      params
    );
  },
  getCompanyFoodKorisnici(companyId, params) {
    return apiService.get(
      `/reports/daily/company/${companyId}/food-korisnici`,
      params
    );
  },
  getCompanyMealKorisnici(companyId, params) {
    return apiService.get(
      `/reports/daily/company/${companyId}/korisnici`,
      params
    );
  },
  getCompanyFoodKorisniciByDay(companyId, params) {
    return apiService.get(
      `/reports/daily/company/${companyId}/food-korisnici-by-day`,
      params
    );
  },
  getRestaurantChildRestaurant(restaurantId, params) {
    return apiService.get(
      `/reports/daily/restaurant/${restaurantId}/child-restaurant`,
      params
    );
  },
  // Added methods for refactored components:
  getRestaurantCompanies(restaurantId, params) {
    return apiService.get(
      `/reports/daily/restaurant/${restaurantId}/companies`,
      params
    );
  },
  getTotalShiftMeals(restaurantId, params) {
    return apiService.get(`/reports/daily/total/${restaurantId}`, params);
  },
  getReservedMeals(restaurantId, params) {
    return apiService.get(
      `/reports/daily/restaurant/${restaurantId}/rezervni-obroci`,
      params
    );
  },
  getReservedMealsV2(restaurantId, params) {
    return apiService.get(
      `/v2/reports/daily/restaurant/${restaurantId}/reserved-meals`,
      params
    );
  },
  async getMealsForRestaurantCompanies(restaurantId, params) {
    const { data } = await apiService.get(
      `/reports/daily/restaurant/${restaurantId}/obrok`,
      params
    );
    const response = transformMealsForRestaurantCompanies(data);
    console.log('response', response);
    return response;
  },
  async getPackagesForRestaurantCompanies(restaurantId, params) {
    const { data } = await apiService.get(
      `/reports/daily/restaurant/${restaurantId}/obrok`,
      params
    );
    const { transformMealsForPackages } = await import("@/mappers/reportMapper");
    return transformMealsForPackages(data);
  },
  getMealsForRestaurant(restaurantId, params) {
    return apiService.get(
      `/reports/daily/restaurant/${restaurantId}/obrok-report`,
      params
    );
  },
  getCompanyUserlist(params) {
    return apiService.post(`/reports/daily/company/userlists`, params);
  },
  getDailyRestaurant(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}`, params);
  },
  getNoContractDelivery(restaurantId, params) {
    return apiService.get(
      `/reports/daily/company/${restaurantId}/no-contract`,
      params
    );
  },
  getCompanyUserList(companyId, params) {
    return apiService.get(
      `reports/daily/company/${companyId}/userlist`,
      params
    );
  },
  // Add these methods for menu and additional meal
  getMenuForCurrentDate(payload) {
    return apiService.post("/menus/get-menu-for-current-date", payload);
  },
  addAdditionalMeal(payload) {
    return apiService.post("/orders/add-additional-meal", payload);
  },
  // New methods for employee order history
  getEmployeeOrdersByMonth(payload) {
    return apiService.post("/user/orders-by-month", payload);
  },
  getEmployeeOrdersByMonthCustom(url, payload) {
    return apiService.post(url, payload);
  },
  // Guest report methods
  getQrTable(restaurantId, params) {
    return apiService.get(`/v2/reports/daily/qr-table/${restaurantId}`, params);
  },
  getQrTableMultiple(params) {
    return apiService.get('/v2/reports/daily/qr-table-multiple', params);
  },
  getMultipleRestaurantGuestObrok(params) {
    return apiService.get('/reports/daily/multiple-restaurant-guest/obrok', params);
  },
  getRestaurantGuestObrok(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant-guest/${restaurantId}/obrok`, params);
  },
  getCompanyGuestKorisnici(companyId, params) {
    return apiService.get(`/reports/daily/company-guest/${companyId}/korisnici`, params);
  },
  getCompanyUserlistGuest(companyIds, params) {
    return apiService.get(`/reports/daily/company/${companyIds}/userlist-guest`, params);
  },
  getCompanyNoContract(restaurantId, params) {
    return apiService.get(`/reports/daily/company/${restaurantId}/no-contract`, params);
  },
  getCompanyMultipleNoContract(params) {
    return apiService.get('/reports/daily/company/multiple-no-contract', params);
  },
  getCompanyNoContractNextDay(restaurantId, params) {
    return apiService.get(`/reports/daily/company/${restaurantId}/no-contract-next-day`, params);
  },
  getMultipleRestaurantGuest(params) {
    return apiService.get('/reports/daily/multiple-restaurant-guest', params);
  },
  getMultipleRestaurantGuestCompanies(params) {
    return apiService.get('/reports/daily/multiple-restaurant-guest/companies', params);
  },
  getMultipleTotalGuest(params) {
    return apiService.get('/reports/daily/multiple-total-guest', params);
  },
  getRestaurantMultipleRezervniObroci(params) {
    return apiService.get('/reports/daily/restaurant/multiple-rezervni-obroci', params);
  },
  getRestaurantMultipleChildRestaurant(params) {
    return apiService.get('/reports/daily/restaurant/multiple-child-restaurant', params);
  },
  getRestaurantGuest(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant-guest/${restaurantId}`, params);
  },
  getRestaurantGuestCompanies(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant-guest/${restaurantId}/companies`, params);
  },
  getTotalGuest(restaurantId, params) {
    return apiService.get(`/reports/daily/total-guest/${restaurantId}`, params);
  },
  getRestaurantRezervniObroci(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}/rezervni-obroci`, params);
  },
  getRestaurantChildRestaurants(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}/child-restaurant`, params);
  },
  // More restaurants methods
  getTotalRestaurantOrders(params) {
    return apiService.get('/reports/daily/restaurant/total-restaurant-orders', params);
  },
  getMoreRestaurantsOrders(params) {
    return apiService.post('/reports/daily/restaurant/more-restaurants-orders', params);
  },
  getCompanyNewsMoreRestaurants(params) {
    return apiService.post('/reports/daily/company-news-more-restaurants', params);
  },
  getCompanyMoreRestaurantUserlists(params) {
    return apiService.post('/reports/daily/company-more-restaurant/userlists', params);
  },
  getMoreRestaurantsCompanyUserlist(companyIds, params) {
    return apiService.get(`/reports/daily/more-restaurants-company/${companyIds}/userlist`, params);
  },
  getRestaurantFirmsReports(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}/firms-reports`, params);
  },
  // Izvestaj.vue methods
  getMoreRestaurantReports(restaurantId, params) {
    return apiService.get(`/reports/daily/more-restaurant/${restaurantId}/reports`, params);
  },
  async getMoreRestaurantReportsNew(restaurantId, params) {
    const { data } = await apiService.get(`/reports/daily/restaurant/${restaurantId}/order-more-restaurants`, params);
    const { transformMealsForRestaurantCompanies } = await import("@/mappers/reportMapper");
    const response = transformMealsForRestaurantCompanies(data);
    return response;
  },
  async getPackagesForMoreRestaurant(restaurantId, params) {
    const { data } = await apiService.get(`/reports/daily/restaurant/${restaurantId}/order-more-restaurants`, params);
    const { transformMealsForPackages } = await import("@/mappers/reportMapper");
    return transformMealsForPackages(data);
  },
  getTotalMoreRestaurants(restaurantId, params) {
    return apiService.get(`/reports/daily/total-more-restaurants/${restaurantId}`, params);
  },
  getFoodOrdersOrdered(restaurantId, params) {
    return apiService.get(`/reports/daily/food-orders-ordered/${restaurantId}`, params);
  },
  getMoreRestaurantFirmsReports(restaurantId, params) {
    return apiService.get(`/reports/daily/more-restaurant/${restaurantId}/firms-reports`, params);
  },
  getReservedMealsFirms(restaurantId) {
    return apiService.get(`/reports/daily/reserved-meals/${restaurantId}/firms`);
  },
  getRestaurantRezervniObroci(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}/rezervni-obroci`, params);
  },
  getRestaurantObrok(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}/obrok`, params);
  },
  getMoreRestaurantObrok(restaurantId, params) {
    return apiService.get(`/reports/daily/more-restaurant/${restaurantId}/obrok`, params);
  },
  getCompanyUserlistfood(companyIds, params) {
    return apiService.get(`/reports/daily/company/${companyIds}/userlistfood`, params);
  },
  getMoreRestaurantsCompanyUserlist(companyIds, params) {
    return apiService.get(`/reports/daily/more-restaurants-company/${companyIds}/userlist`, params);
  },
  getCompanyMoreRestaurantsKorisnici(companyId, params) {
    return apiService.get(`/reports/daily/company-more-restaurants/${companyId}/korisnici`, params);
  },
  getRestaurantCompanies(restaurantId, params) {
    return apiService.get(`/reports/daily/get-restaurant-companies/${restaurantId}`, params);
  },
  getRestaurantReportCompanies(restaurantId, params) {
    return apiService.get(`/reports/daily/restaurant/${restaurantId}/companies`, params);
  },
  getRestaurantTotal(restaurantId, params) {
    return apiService.get(`/reports/daily/total/${restaurantId}`, params);
  },
  getCompanyFoodKorisnici(companyIds, params) {
    return apiService.get(`/reports/daily/company/${companyIds}/food-korisnici`, params);
  },
  // Change order status
  changeOrderStatus(data) {
    return apiService.post(`/reports/change-order-status`, data);
  },
  // Export report to Excel
  exportToExcel(data, config = {}) {
    return apiService.post(`/reports/export-excel`, data, {
      responseType: 'blob',
      ...config
    });
  },
  // Get company locations
  getCompanyLocations(data) {
    return apiService.post(`/reports/daily/company/locations`, data);
  },
  // Get company userlists
  getCompanyUserlists(data) {
    return apiService.post(`/reports/daily/company/userlists`, data);
  },
  // Fetch credit report. Expect params to include any filters (date, date2, company_ids, etc.).
  getCreditUser(params = {}) {
    return apiService.get(`/credits/report`, params);
  },
};

export default reportService;
